import Vue from 'vue'
import VueStripe from '@/libraries/stripe';

Vue.use(VueStripe)
